import { render, staticRenderFns } from "./terminalAuthorizationComponent.vue?vue&type=template&id=418bbf06&scoped=true&"
import script from "./terminalAuthorizationComponent.vue?vue&type=script&lang=js&"
export * from "./terminalAuthorizationComponent.vue?vue&type=script&lang=js&"
import style0 from "./terminalAuthorizationComponent.vue?vue&type=style&index=0&id=418bbf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418bbf06",
  null
  
)

export default component.exports